import React from "react";
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from "react-router-dom";

import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { excludeGraphQLFetch } from "apollo-link-sentry";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  beforeSend: (event) => {
    const headers = event.request?.headers;
    const headerUserAgent =
      headers?.["User-Agent"] || headers?.["user-agent"] || "";
    const ua =
      headerUserAgent ||
      (typeof navigator !== "undefined" ? navigator.userAgent || "" : "");
    // detecting old mobile browsers using the user agent string and filtering out any errors from them
    const isOldMobileSafari =
      /Version\/(\d+).*Mobile.*Safari/.test(ua) &&
      parseInt(ua.match(/Version\/(\d+)/)?.[1]) < 14;
    const isOldChromeMobileIOS =
      /CriOS\/(\d+)/.test(ua) && parseInt(ua.match(/CriOS\/(\d+)/)?.[1]) < 94;
    const isOldMobileBrowser = isOldMobileSafari || isOldChromeMobileIOS;

    if (isOldMobileBrowser) return null;

    return event;
  },
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV6Instrumentation(
        React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      ),
      tracePropagationTargets: [process.env.REACT_APP_API_ENDPOINT, /\//],
    }),
  ],
  environment: process.env.REACT_APP_SENTRY_ENV,
  beforeBreadcrumb: excludeGraphQLFetch,
  tracesSampleRate: 0.1,
  ignoreErrors: [
    "ResizeObserver loop completed with undelivered notifications",
    "ResizeObserver loop limit exceeded",
  ],
});
